/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import classnames from 'classnames';
import SocialNetwork from '@components/SocialNetwork';
import HoneywoodLogo from '@src/assets/Footer/honeywood_logo_bw.png';
import MonetaTodayLogo from '@src/assets/Footer/monetatoday_logo_bw.png';
import styles from './footer.module.scss';

const Footer = () => {
  // const location = useLocation();
  // const toTop = () => {
  //   window.scrollTo(0, 0);
  // };

  return (

    <footer className={styles.MainContainer}>
      <div className={styles.LogoContainer}>
        <a target="_blank" rel="noreferrer" href="https://honeywood.io/">
          <img src={HoneywoodLogo} alt="honeywood_logo_bw" className={styles.HoneywoodLogo} />
        </a>
        <p className={styles.HoneywoodLogoText}>HoneyWood Blockchain&nbsp;game</p>
        <a
          href="mailto:media@honeywood.io"
          target="_blank"
          rel="noreferrer"
          className={styles.MailLink}
        >
          media@honeywood.io
        </a>
      </div>
      <div className={styles.InfoContainer}>
        <div className={styles.ItemContainer}>
          <p className={styles.ItemTitle}>Explorer</p>
          <a href="#" target="_blank" rel="noreferrer">
            <p className={styles.ItemLinkText}>Transactions</p>
          </a>
          <a href="#" target="_blank" rel="noreferrer">
            <p className={styles.ItemLinkText}>Blocks</p>
          </a>
          <a href="#" target="_blank" rel="noreferrer">
            <p className={styles.ItemLinkText}>Validators</p>
          </a>
          <a href="#" target="_blank" rel="noreferrer">
            <p className={styles.ItemLinkText}>Proposals</p>
          </a>
          <a href="#" target="_blank" rel="noreferrer">
            <p className={styles.ItemLinkText}>Events</p>
          </a>
          <a href="#" target="_blank" rel="noreferrer">
            <p className={styles.ItemLinkText}>IBC Channels</p>
          </a>
        </div>

        <div className={styles.ItemContainer}>
          <p className={styles.ItemTitle}>Tools</p>
          <a href="#" target="_blank" rel="noreferrer">
            <p className={styles.ItemLinkText}>Wallets</p>
          </a>
        </div>

        <div className={styles.ItemContainer}>
          <p className={styles.ItemTitle}>Resources</p>
          <a href="#" target="_blank" rel="noreferrer">
            <p className={styles.ItemLinkText}>Cosmos.network</p>
          </a>
          <a href="#" target="_blank" rel="noreferrer">
            <p className={styles.ItemLinkText}>Documentation</p>
          </a>
          <a href="#" target="_blank" rel="noreferrer">
            <p className={styles.ItemLinkText}>Community</p>
          </a>
        </div>

        <div className={styles.ItemContainer}>
          <p className={styles.ItemTitle}>Networks</p>
          <a href="#" target="_blank" rel="noreferrer">
            <p className={styles.ItemLinkText}>Mainnet</p>
          </a>
          <a href="#" target="_blank" rel="noreferrer">
            <p className={styles.ItemLinkText}>TestNet</p>
          </a>
        </div>
      </div>
      <div className={styles.ContactsContainer}>
        <SocialNetwork
          classNames={{
            Container: styles.SocialNetworkContainer,
          }}
        />
        <div className={styles.LogoAndRightsContainer}>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://moneta.today"
            className={styles.MonetaTodayLogoLink}
          >
            <img
              src={MonetaTodayLogo}
              alt="monetatoday_logo_bw"
              className={styles.MonetaTodayLogo}
            />
          </a>
          <div className={styles.RightsContainer}>
            <p className={styles.RightsText}>MToday OÜ © All&nbsp;rights&nbsp;reserved</p>
            <div className={styles.PrivacyAndTermsContainer}>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://honeywood.io/files/privacy-policy.pdf"
                // href={URLS.PRIVACY_POLICY}
                className={classnames(styles.RightsText, styles.PrivacyLink)}
              >
                Privacy
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://honeywood.io/files/terms-of-use.pdf"
                // href={URLS.TERMS_OF_USE}
                className={classnames(styles.RightsText, styles.TermsLink)}
              >
                Terms & conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>

    // <footer className={styles.MainContainer}>
    //   {/* <img
    //     src={Code}
    //     alt="Code"
    //     loading="lazy"
    //     className={styles.Code}
    //   /> */}
    //   <div className={styles.Container}>
    //     <div className={styles.TopContainer}>
    //       <div className={styles.FooterInfoContainer}>
    //         <img
    //           src={HoneywoodLogo}
    //           className={styles.HoneywoodLogo}
    //           alt="honeywood_logo_bw"
    //         />
    //         <p className={styles.FooterTitle}>
    //           Powered by Moneta Ecosystem
    //         </p>
    //       </div>
    //     </div>
    //     <div className={styles.BottomContainer}>
    //       <p className={styles.CopyrightText}>
    //         MToday OÜ © All rights reserved
    //       </p>
    //       <div className={styles.Mail}>
    //         <a
    //           href="mailto:contact@moneta.today"
    //           className={styles.MailLink}
    //           target="_blank"
    //           rel="noreferrer"
    //           onClick={() => {
    //             // gtagEvent(GOOGLE_ANALYTICS_CONSTANTS.CLICK_MAIL);
    //           }}
    //         >
    //           <img
    //             src={Envelope}
    //             alt="Envelope"
    //             loading="lazy"
    //             className={styles.MailIcon}
    //           />
    //           <p className={styles.MailText}>Contact Us</p>
    //         </a>
    //       </div>
    //     </div>
    //   </div>
    // </footer>
  );
};

export default Footer;
